import { API } from '@/constants/api';
import http from '@/http';
import { alertError } from '@/utils/notification';
import { camelize, snakelize } from '@/utils/parse';
import { generatePath } from 'react-router-dom';

export async function list() {
  try {
    const { data } = await http.get(API.PACKAGE.LIST);
    return {
      success: true,
      data: camelize(data),
    };
  } catch (error) {
    if (error.response) {
      const {
        response: { data },
      } = error;
      const { errorCode } = camelize(data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function getDetail({ id }) {
  try {
    const url = generatePath(API.PACKAGE.DETAIL, { id });
    const { data } = await http.get(url);
    return {
      success: true,
      data: camelize(data),
    };
  } catch (error) {
    if (error.response) {
      const {
        response: { data },
      } = error;
      const { errorCode } = camelize(data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function subscribe({
  packageId,
  customerFirstName,
  customerLastName,
  customerTaxNumber,
  customerEmail,
  customerPhone,
  customerCountry,
  customerCity,
  customerDistrict,
  customerZipcode,
  customerAddress,
  isStoreBillingInfo,
  customerSubDistrict,
}) {
  try {
    const payload = snakelize({
      packageId,
      customerFirstName,
      customerLastName,
      customerTaxNumber,
      customerEmail,
      customerPhone,
      customerZipcode,
      customerAddress,
      isStoreBillingInfo,
      customerCountry: customerCountry.value,
      customerProvince: customerCity.value,
      customerDistrict: customerDistrict.value,
      customerWard: customerSubDistrict.value,
    });
    const { data } = await http.post(API.PACKAGE.SUBSCRIBE, payload);
    return {
      success: true,
      data: camelize(data),
    };
  } catch (error) {
    if (error.response) {
      const {
        response: { data },
      } = error;
      const { errorCode } = camelize(data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}

export async function getCurrentSubscription() {
  try {
    const { data } = await http.get(API.SUBSCRIPTION.CURRENT);
    return {
      success: true,
      data: camelize(data),
    };
  } catch (error) {
    if (error.response) {
      const {
        response: { data, status },
      } = error;
      if (status === 404) {
        return {
          success: true,
          data: {},
        };
      }
      const { errorCode } = camelize(data);
      alertError(errorCode);
    } else {
      alertError('APPLICATION_ERROR');
    }
    return {
      success: false,
    };
  }
}
